(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-admin"]) return;
  try {
    
(async function() {

    //if ( !document.body.classList.contains('template-suffix-admin') ) return;
    document.body.classList.add(':loading');

    // dom ready
    await new Promise((resolve) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", resolve);
        } else {
            resolve();
        }
    });

    // ref elems
    var grid = document.querySelector('#wvzhtxyq75 .product-grid');
    var next = document.querySelector('#wvzhtxyq75 .pagination .pagination__next');
    document.querySelector('#wvzhtxyq75 .pagination').remove();

    while (next) {

        console.log(`LOADING: ${next.href}`);
        // do ajax
        next = await fetch(next.href)
        .then(response => response.text())
        .then(data => {
            // parse str as html
            const nextPage = new DOMParser().parseFromString(data, 'text/html');

            // append to grid
            grid.append(...nextPage.querySelectorAll('#wvzhtxyq75 .product-grid .product-block'));

            // is there next-next page?
            return nextPage.querySelector('#wvzhtxyq75 .pagination .pagination__next');
        });

    }

    let data = [...document.querySelectorAll('#wvzhtxyq75 .product-grid .product-block')]
        .reduce((a,c)=>{
            let g = c.dataset.group;
            if (!a[g]) a[g] = [];
            a[g].push({
                color: c.querySelector('.product-block-options__item__text').innerHTML,
                html: c.outerHTML
            });
            return a;
        }, {});

    data = Object.fromEntries(
        Object.keys(data)
        .sort()
        .map(key => {
            let x = 'color';
            let val = data[key].sort((a, b) => ( a[x] < b[x] ? -1 : a[x] > b[x] ? 1 : 0 ));
            return [ key, val ];
        })
    );
    //console.log(data);

    window.data = data;
    window.page_html = document.body.innerHTML;
    // Restore with: document.body.innerHTML = window.page_html;

    let output = [];
    for (const item in data) {
      output.push(`${Object.values(data[item])[0].html}`);
    }
    //console.log(output.join(""));
    document.querySelector('#wvzhtxyq75 .product-grid').innerHTML = output.join("");

    console.log('LOAD ALL PRODUCTS - COMPLETE');
    document.body.classList.remove(':loading');
    
    return;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-swatches"]) return;
  try {
    
(async function() {

    //if ( !document.body.classList.contains('template-suffix-swatches') ) return;
    document.body.classList.add(':loading');

    // dom ready
    await new Promise((resolve) => {
        if (document.readyState === "loading") {
            document.addEventListener("DOMContentLoaded", resolve);
        } else {
            resolve();
        }
    });

    // ref elems
    var grid = document.querySelector('#grly3txdeg .product-grid');
    var next = document.querySelector('#grly3txdeg .pagination .pagination__next');
    document.querySelector('#grly3txdeg .pagination').remove();

    while (next) {

        console.log(`LOADING: ${next.href}`);
        // do ajax
        next = await fetch(next.href)
        .then(response => response.text())
        .then(data => {
            // parse str as html
            const nextPage = new DOMParser().parseFromString(data, 'text/html');

            // append to grid
            grid.append(...nextPage.querySelectorAll('#grly3txdeg .product-grid .product-block'));

            // is there next-next page?
            return nextPage.querySelector('#grly3txdeg .pagination .pagination__next');
        });

    }

    let data = [...document.querySelectorAll('#grly3txdeg .product-grid .product-block')]
        .reduce((a,c)=>{
            let g = c.dataset.group;
            if (!a[g]) a[g] = [];
            a[g].push({
                //id: c.dataset.id,
                url: c.dataset.handle,
                img: new URL(c.querySelector('img').src).pathname.split("/").pop(),
                color: c.querySelector('.product-block-options__item__text').innerHTML
            });
            return a;
        }, {});
        
    data = Object.fromEntries(
        Object.keys(data)
        .filter(key => (data[key].length > 1))
        .sort()
        .map(key => {
            let x = 'color';
            let val = data[key].sort((a, b) => ( a[x] < b[x] ? -1 : a[x] > b[x] ? 1 : 0 ));
            return [ key, val ];
        })
        //.reduce((res, key) => (res[key] = data[key], delete res[key].id, res), {})
    );
    //console.log(data);

    window.data = data;
    window.page_html = document.body.innerHTML;
    // Restore with: document.body.innerHTML = window.page_html;
    document.body.innerHTML = `<textarea readonly id="grly3txdeg_jsondata">${JSON.stringify(data)}</textarea>`;

    console.log('LOAD ALL PRODUCTS - COMPLETE');
    document.body.classList.remove(':loading');
    grly3txdeg_jsondata.select();
    
    return;

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
